// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image
// } from "@react-pdf/renderer";


// const styles = StyleSheet.create({
//   // page: {
//   //   padding: 5,
//   //   fontSize: 6,
//   //   flexDirection: "column",
//   // },
//   // section: {
//   //   marginBottom: 10,
//   //   marginTop: 80,
//   // },
//   page: {
//     paddingTop: 90,   // space for header
//     paddingBottom: 80, // space for footer
//     paddingHorizontal: 10,
//     fontSize: 6,
//     flexDirection: "column",
//   },
//   section: {
//     marginBottom: 10,
//   },
//   headerWrapper: {
//     position: "absolute",
//     top: 15,
//     left: 20,
//     right: 20,
//     height: 50,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   headerImage: {
//     width: "100%",
//     height: 50,
//     objectFit: "contain",
//   },

//   headerContainer: {
//     alignItems: "center",
//     marginTop: 15,
//   },
//   headerText: {
//     fontSize: 13,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 8,
//   },

//   /* FOOTER */
//   footerWrapper: {
//     position: "absolute",
//     bottom: 25,
//     left: 5,
//     right: 5,
//     height: 80,
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   footerImage: {
//     width: "100%",
//     height: 100,
//     objectFit: "cover",
//   },

//   table: {
//     display: "table",
//     width: "100%",
//     borderWidth: 1,
//     borderColor: "#000",
//     borderStyle: "solid",
//     borderBottomWidth: 0
//   },
//   tableRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: "#000",
//     borderBottomStyle: "solid",
//   },
//   headerCell: {
//     flex: 6,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   headerCell1: {
//     flex: 0.5,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   headerText: {
//     fontSize: 12,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 10
//   },
//   headerCell2hol: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     // color: "#ab003c",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   headerCell2: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },

//   headerCell2Total: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     // borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   cell: {
//     flex: 6,
//     padding: 2,
//     textAlign: 'left',
//     borderRightWidth: 1,
//     borderColor: "#000",
//   },
//   cell1: {
//     flex: 0.5,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   cell2: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },

//   cell2ColStaus: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     // borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold", // BOLD header text
//   },
//   legendContainer: {
//     flexDirection: "row",
//     flexWrap: "wrap",
//     marginBottom: 6,
//     gap: 10,
//   },

//   legendText: {
//     fontSize: 7,
//     fontWeight: "bold",
//   },

// });

// // const paginateData = (data) => {
// //   if (!Array.isArray(data)) return [];
// //   const firstPage = data.slice(0, 20);
// //   const otherPages = [];

// //   for (let i = 20; i < data.length; i += 26) {
// //     otherPages.push(data.slice(i, i + 26));
// //   }

// //   return [firstPage, ...otherPages];
// // };
// const paginateData = (data) => {
//   if (!Array.isArray(data)) return [];
//   const firstPage = data.slice(0, 20);
//   const otherPages = [];

//   for (let i = 20; i < data.length; i += 26) {
//     otherPages.push(data.slice(i, i + 26));
//   }

//   return [firstPage, ...otherPages];
// };
// const AttendanceHistoryPDF = ({ data = [], filters = {}, footerHeight }) => {
//   const pages = paginateData(data);
//   const monthNames = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December"
//   ];

//   //   // ✅ Dynamic Day Color Function
//   // const getDayStyle = (value) => {
//   //   switch (value) {
//   //     case "WO":
//   //       return { color: "#ab003c", backgroundColor: "#ffe6ee" };
//   //     case "HO":
//   //       return { color: "#0b5ed7", backgroundColor: "#e7f1ff" };
//   //     case "L":
//   //       return { color: "#ff8c00", backgroundColor: "#fff3cd" };
//   //     case "A":
//   //       return { color: "#dc3545" };
//   //     default:
//   //       return {};
//   //   }
//   // };
//   const getDayStyle = (value) => {
//     switch (value) {
//       case "WO":
//         return {
//           color: "#dc3545",
//           backgroundColor: "#ffe6ee"
//         };

//       case "HO":
//         return {
//           color: "#0b5ed7",
//           backgroundColor: "#e7f1ff"
//         };

//       case "L":
//       case "CL":
//       case "ML":
//       case "SL":
//         return {
//           color: "#ff8c00",
//           backgroundColor: "#fff3cd"
//         };

//       case "IR":
//         return {
//           color: "#6f42c1",          // Purple for IR
//           backgroundColor: "#f3e8ff"
//         };

//       case "A":
//         return {
//           color: "#20c997",          // Teal for A
//           backgroundColor: "#e6fffa"
//         };

//       default:
//         return {};
//     }
//   };


//   return (
//     <Document>
//       {pages.map((pageData, pageIndex) => (
//         <Page size="A4"
//           orientation="landscape"
//           // style={styles.page} 
//           style={{
//             paddingBottom: footerHeight,
//             paddingTop: 90,   // space for header
//             paddingHorizontal: 10,
//             fontSize: 6,
//             flexDirection: "column",
//           }}
//           key={pageIndex}>
//           <View fixed style={styles.headerWrapper}>
//             {filters.HeaderImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
//                 style={styles.headerImage}
//               />
//             )}
//           </View>
//           {pageIndex === 0 && (
//             <View style={styles.section}>
//               {/* <Text style={{ fontSize: 10, marginBottom: 4 }}>Attendance Report</Text>
//               <Text>Month: {monthNames[filters.Month - 1]}</Text>
//               <Text>Year: {filters.Year}</Text> */}
//               <Text style={styles.headerText}>
//                 {`Monthly Attendance Report (${monthNames[filters.Month - 1]} - ${filters.Year})`}
//               </Text>
//             </View>
//           )}
//           {/* Legends */}
//           <View style={styles.legendContainer}>
//             <Text style={styles.legendText}>{"P -> Present"}</Text>
//             <Text style={styles.legendText}>{"SH -> Second Half"}</Text>
//             <Text style={styles.legendText}>{"CL -> Casual Leave"}</Text>
//             <Text style={styles.legendText}>{"M -> Medical Leave"}</Text>
//             <Text style={styles.legendText}>{"UL -> Unscheduled Leave"}</Text>
//             <Text style={styles.legendText}>{"HO -> Holiday"}</Text>
//             <Text style={styles.legendText}>{"WO -> Week Off"}</Text>
//             {/* <Text style={styles.legendText}>{"L -> Leave"}</Text> */}
//             <Text style={styles.legendText}>{"IR -> IR Regular"}</Text>
//           </View>

//           <View style={styles.table}>
//             {/* Header Row */}
//             <View style={styles.tableRow}>
//               <Text style={styles.headerCell1}>SL#</Text>
//               <Text style={styles.headerCell}>EMPLOYEE</Text>
//               {/* <Text style={styles.headerCell1}>1</Text>
//               <Text style={styles.headerCell1}>2</Text>
//               <Text style={styles.headerCell1}>3</Text>
//               <Text style={styles.headerCell1}>4</Text>
//               <Text style={styles.headerCell1}>5</Text>
//               <Text style={styles.headerCell1}>6</Text>
//               <Text style={styles.headerCell1}>7</Text>
//               <Text style={styles.headerCell1}>8</Text>
//               <Text style={styles.headerCell1}>9</Text>
//               <Text style={styles.headerCell1}>10</Text>
//               <Text style={styles.headerCell1}>11</Text>
//               <Text style={styles.headerCell1}>12</Text>
//               <Text style={styles.headerCell1}>13</Text>
//               <Text style={styles.headerCell1}>14</Text>
//               <Text style={styles.headerCell1}>15</Text>
//               <Text style={styles.headerCell1}>16</Text>
//               <Text style={styles.headerCell1}>17</Text>
//               <Text style={styles.headerCell1}>18</Text>
//               <Text style={styles.headerCell1}>19</Text>
//               <Text style={styles.headerCell1}>20</Text>
//               <Text style={styles.headerCell1}>21</Text>
//               <Text style={styles.headerCell1}>22</Text>
//               <Text style={styles.headerCell1}>23</Text>
//               <Text style={styles.headerCell1}>24</Text>
//               <Text style={styles.headerCell1}>25</Text>
//               <Text style={styles.headerCell1}>26</Text>
//               <Text style={styles.headerCell1}>27</Text>
//               <Text style={styles.headerCell1}>28</Text>
//               <Text style={styles.headerCell1}>29</Text>
//               <Text style={styles.headerCell1}>30</Text>
//               <Text style={styles.headerCell1}>31</Text> */}

//               {Array.from({ length: 31 }, (_, i) => (
//                 <Text key={i} style={styles.headerCell1}>{i + 1}</Text>
//               ))}
//               {/* <Text style={styles.headerCell}>Present</Text>
//       <Text style={styles.headerCell}>Leave</Text>
//       <Text style={styles.headerCell}>UNPAIDLEAVE</Text>
//       <Text style={styles.headerCell}>Absent</Text>
//       <Text style={styles.headerCell}>IRREGULAR</Text>
//       <Text style={styles.headerCell}>HOLIDAYS</Text>
//       <Text style={styles.headerCell}>Weekoff</Text> */}
//               <Text style={styles.headerCell2}>P</Text>
//               {/* <Text style={styles.headerCell2}>L</Text> */}
//               <Text style={styles.headerCell2hol}>UL</Text>
//               <Text style={styles.headerCell2}>SL</Text>
//               {/* <Text style={styles.headerCell2}>IR</Text> */}
//               <Text style={styles.headerCell2hol}>HOL</Text>
//               <Text style={styles.headerCell2hol}>WO</Text>
//               <Text style={styles.headerCell2Total}>Total</Text>
//             </View>

//             {/* Table Body */}
//             {pageData.map((row, rowIndex) => (
//               <View key={rowIndex} style={styles.tableRow}>
//                 <Text style={styles.cell1}>{row.SLNO}</Text>
//                 <Text style={styles.cell}>{row.Name}</Text>
//                 {/* <Text style={styles.cell1}>{row.Day1}</Text>
//                 <Text style={styles.cell1}>{row.Day2}</Text>
//                 <Text style={styles.cell1}>{row.Day3}</Text>
//                 <Text style={styles.cell1}>{row.Day4}</Text>
//                 <Text style={styles.cell1}>{row.Day5}</Text>
//                 <Text style={styles.cell1}>{row.Day6}</Text>
//                 <Text style={styles.cell1}>{row.Day7}</Text>
//                 <Text style={styles.cell1}>{row.Day8}</Text>
//                 <Text style={styles.cell1}>{row.Day9}</Text>
//                 <Text style={styles.cell1}>{row.Day10}</Text>
//                 <Text style={styles.cell1}>{row.Day11}</Text>
//                 <Text style={styles.cell1}>{row.Day12}</Text>
//                 <Text style={styles.cell1}>{row.Day13}</Text>
//                 <Text style={styles.cell1}>{row.Day14}</Text>
//                 <Text style={styles.cell1}>{row.Day15}</Text>
//                 <Text style={styles.cell1}>{row.Day16}</Text>
//                 <Text style={styles.cell1}>{row.Day17}</Text>
//                 <Text style={styles.cell1}>{row.Day18}</Text>
//                 <Text style={styles.cell1}>{row.Day19}</Text>
//                 <Text style={styles.cell1}>{row.Day20}</Text>
//                 <Text style={styles.cell1}>{row.Day21}</Text>
//                 <Text style={styles.cell1}>{row.Day22}</Text>
//                 <Text style={styles.cell1}>{row.Day23}</Text>
//                 <Text style={styles.cell1}>{row.Day24}</Text>
//                 <Text style={styles.cell1}>{row.Day25}</Text>
//                 <Text style={styles.cell1}>{row.Day26}</Text>
//                 <Text style={styles.cell1}>{row.Day27}</Text>
//                 <Text style={styles.cell1}>{row.Day28}</Text>
//                 <Text style={styles.cell1}>{row.Day29}</Text>
//                 <Text style={styles.cell1}>{row.Day30}</Text>
//                 <Text style={styles.cell1}>{row.Day31}</Text> */}

//                 {/* ✅ Dynamic Days */}
//                 {Array.from({ length: 31 }, (_, i) => {
//                   const dayValue = row[`Day${i + 1}`];
//                   return (
//                     <Text
//                       key={i}
//                       style={[styles.cell1, getDayStyle(dayValue)]}
//                     >
//                       {dayValue}
//                     </Text>
//                   );
//                 })}
//                 <Text style={styles.cell2}>{row.Present}</Text>
//                 {/* <Text style={styles.cell2}>{row.Leave}</Text> */}
//                 <Text style={styles.cell2}>{row.UnPaidLeave}</Text>
//                 <Text style={styles.cell2}>{row.PaidLeave}</Text>
//                 {/* <Text style={styles.cell2}>{row.IRREGULAR}</Text> */}
//                 <Text style={styles.cell2}>{row.Holidays}</Text>
//                 <Text style={styles.cell2}>{row.Weekoff}</Text>
//                 <Text style={styles.cell2ColStaus}>{row.Total}</Text>
//               </View>
//             ))}
//           </View>
//           <View fixed
//             //  style={styles.footerWrapper}
//             style={{
//               position: "absolute",
//               bottom: 25,
//               left: 5,
//               right: 5,
//               height: footerHeight, // 🔥 dynamic
//             }}
//           >
//             {filters.FooterImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
//                 // style={styles.footerImage}
//                 style={{
//                   width: "100%",
//                   height: "100%",
//                 }}
//               />
//             )}
//           </View>
//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default AttendanceHistoryPDF;





import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    paddingTop: 90,
    paddingBottom: 80,
    paddingHorizontal: 10,
    fontSize: 6,
    flexDirection: "column",
  },
  section: {
    marginBottom: 10,
  },
  headerWrapper: {
    position: "absolute",
    top: 15,
    left: 20,
    right: 20,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  headerImage: {
    width: "100%",
    height: 50,
    objectFit: "contain",
  },
  headerText: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "table",
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
  },
  headerCell: {
    flex: 6,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  headerCell1: {
    flex: 0.5,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  headerCell2: {
    flex: 1,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  headerCell2hol: {
    flex: 1,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  headerCell2Total: {
    flex: 1,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderColor: "#000",
    fontWeight: "bold",
  },
  cell: {
    flex: 6,
    padding: 2,
    textAlign: "left",
    borderRightWidth: 1,
    borderColor: "#000",
  },
  cell1: {
    flex: 0.5,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  cell2: {
    flex: 1,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderRightWidth: 1,
    borderColor: "#000",
    fontWeight: "bold",
  },
  cell2ColStaus: {
    flex: 1,
    padding: 2,
    backgroundColor: "#eee",
    textAlign: "center",
    borderColor: "#000",
    fontWeight: "bold",
  },
  legendContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 6,
    gap: 10,
  },
  legendText: {
    fontSize: 7,
    fontWeight: "bold",
  },
});

// ✅ Attendance pagination: 20 rows on first page, 26 on subsequent pages
const paginateData = (data, firstPageRows = 20, otherPageRows = 26) => {
  if (!Array.isArray(data)) return [];
  const pages = [];
  pages.push(data.slice(0, firstPageRows));
  for (let i = firstPageRows; i < data.length; i += otherPageRows) {
    pages.push(data.slice(i, i + otherPageRows));
  }
  return pages;
};

// ✅ Summary pagination: 28 rows per page
const paginateSummary = (data, rowsPerPage = 28) => {
  if (!Array.isArray(data)) return [];
  const pages = [];
  for (let i = 0; i < data.length; i += rowsPerPage) {
    pages.push(data.slice(i, i + rowsPerPage));
  }
  return pages;
};

const AttendanceHistoryPDF = ({ data = [], filters = {}, footerHeight }) => {
  const pages = paginateData(data);           // attendance pages
  const summaryPages = paginateSummary(data); // summary pages

  // ✅ Total pages across both sections
  const totalPages = pages.length + summaryPages.length;

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  // ✅ Day color styling
  const getDayStyle = (value) => {
    switch (value) {
      case "WO":
        return { color: "#dc3545", backgroundColor: "#ffe6ee" };
      case "HO":
        return { color: "#0b5ed7", backgroundColor: "#e7f1ff" };
      case "L":
      case "CL":
      case "ML":
      case "SL":
        return { color: "#ff8c00", backgroundColor: "#fff3cd" };
      case "IR":
        return { color: "#6f42c1", backgroundColor: "#f3e8ff" };
      case "A":
        return { color: "#20c997", backgroundColor: "#e6fffa" };
      default:
        return {};
    }
  };

  // ✅ Reusable header
  const renderHeader = () => (
    <View fixed style={styles.headerWrapper}>
      {filters.HeaderImg && (
        <Image
          src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
          style={styles.headerImage}
        />
      )}
    </View>
  );

  // ✅ Reusable footer with page number
  const renderFooter = (pageNum) => (
    <>
      <View
        fixed
        style={{
          position: "absolute",
          bottom: 25,
          left: 5,
          right: 5,
          height: footerHeight,
        }}
      >
        {filters.FooterImg && (
          <Image
            src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
            style={{ width: "100%", height: "100%" }}
          />
        )}
      </View>
      <View
        fixed
        style={{
          position: "absolute",
          bottom: 10,
          left: 0,
          right: 0,
          textAlign: "center",
          fontSize: 10,
        }}
      >
        <Text>Page {pageNum} of {totalPages}</Text>
      </View>
    </>
  );

  // ✅ Reusable summary table renderer
  const renderSummaryTable = (rows) => (
    <View style={[styles.table, { marginTop: 5 }]}>
      <View style={styles.tableRow}>
        <Text style={styles.headerCell1}>SL#</Text>
        <Text style={styles.headerCell}>EMPLOYEE</Text>
        <Text style={styles.headerCell2}>P</Text>
        <Text style={styles.headerCell2}>UL</Text>
        <Text style={styles.headerCell2}>SL</Text>
        <Text style={styles.headerCell2}>HOL</Text>
        <Text style={styles.headerCell2}>WO</Text>
        <Text style={styles.headerCell2Total}>Total</Text>
      </View>
      {rows.map((row, rowIndex) => (
        <View key={rowIndex} style={styles.tableRow}>
          <Text style={styles.cell1}>{row.SLNO}</Text>
          <Text style={styles.cell}>{row.Name}</Text>
          <Text style={styles.cell2}>{row.Present}</Text>
          <Text style={styles.cell2}>{row.UnPaidLeave}</Text>
          <Text style={styles.cell2}>{row.PaidLeave}</Text>
          <Text style={styles.cell2}>{row.Holidays}</Text>
          <Text style={styles.cell2}>{row.Weekoff}</Text>
          <Text style={styles.cell2ColStaus}>{row.Total}</Text>
        </View>
      ))}
    </View>
  );

  return (
    <Document>

      {/* ==================== ATTENDANCE PAGES ==================== */}
      {pages.map((pageData, pageIndex) => (
        <Page
          key={`att-${pageIndex}`}
          size="A4"
          orientation="landscape"
          style={{
            paddingBottom: footerHeight,
            paddingTop: 90,
            paddingHorizontal: 10,
            fontSize: 6,
            flexDirection: "column",
          }}
        >
          {renderHeader()}

          {/* Title — first page only */}
          {pageIndex === 0 && (
            <View style={styles.section}>
              <Text style={styles.headerText}>
                {`Monthly Attendance Report (${monthNames[filters.Month - 1]} - ${filters.Year})`}
              </Text>
            </View>
          )}

          {/* Legends */}
          <View style={styles.legendContainer}>
            <Text style={styles.legendText}>{"P -> Present"}</Text>
            <Text style={styles.legendText}>{"SH -> Second Half"}</Text>
            <Text style={styles.legendText}>{"CL -> Casual Leave"}</Text>
            <Text style={styles.legendText}>{"M -> Medical Leave"}</Text>
            <Text style={styles.legendText}>{"UL -> Unscheduled Leave"}</Text>
            <Text style={styles.legendText}>{"HO -> Holiday"}</Text>
            <Text style={styles.legendText}>{"WO -> Week Off"}</Text>
            <Text style={styles.legendText}>{"IR -> IR Regular"}</Text>
          </View>

          {/* Attendance Table */}
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.headerCell1}>SL#</Text>
              <Text style={styles.headerCell}>EMPLOYEE</Text>
              {Array.from({ length: 31 }, (_, i) => (
                <Text key={i} style={styles.headerCell1}>{i + 1}</Text>
              ))}
              <Text style={styles.headerCell2}>P</Text>
              <Text style={styles.headerCell2hol}>UL</Text>
              <Text style={styles.headerCell2}>SL</Text>
              <Text style={styles.headerCell2hol}>HOL</Text>
              <Text style={styles.headerCell2hol}>WO</Text>
              <Text style={styles.headerCell2Total}>Total</Text>
            </View>

            {pageData.map((row, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                <Text style={styles.cell1}>{row.SLNO}</Text>
                <Text style={styles.cell}>{row.Name}</Text>
                {Array.from({ length: 31 }, (_, i) => {
                  const dayValue = row[`Day${i + 1}`];
                  return (
                    <Text key={i} style={[styles.cell1, getDayStyle(dayValue)]}>
                      {dayValue}
                    </Text>
                  );
                })}
                <Text style={styles.cell2}>{row.Present}</Text>
                <Text style={styles.cell2}>{row.UnPaidLeave}</Text>
                <Text style={styles.cell2}>{row.PaidLeave}</Text>
                <Text style={styles.cell2}>{row.Holidays}</Text>
                <Text style={styles.cell2}>{row.Weekoff}</Text>
                <Text style={styles.cell2ColStaus}>{row.Total}</Text>
              </View>
            ))}
          </View>

          {renderFooter(pageIndex + 1)}
        </Page>
      ))}

      {/* ==================== SUMMARY PAGES (each on its own new page) ==================== */}
      {summaryPages.map((summaryPageData, i) => (
        <Page
          key={`sum-${i}`}
          size="A4"
          orientation="landscape"
          style={{
            paddingBottom: footerHeight,
            paddingTop: 90,
            paddingHorizontal: 10,
            fontSize: 6,
            flexDirection: "column",
          }}
        >
          {renderHeader()}

          <View style={styles.section}>
            <Text style={styles.headerText}>
              {`Summary Report (${monthNames[filters.Month - 1]} - ${filters.Year})`}
            </Text>
          </View>

    {/* Legends */}
          <View style={styles.legendContainer}>
            <Text style={styles.legendText}>{"P -> Present"}</Text>
            <Text style={styles.legendText}>{"SH -> Second Half"}</Text>
            <Text style={styles.legendText}>{"CL -> Casual Leave"}</Text>
            <Text style={styles.legendText}>{"M -> Medical Leave"}</Text>
            <Text style={styles.legendText}>{"UL -> Unscheduled Leave"}</Text>
            <Text style={styles.legendText}>{"HO -> Holiday"}</Text>
            <Text style={styles.legendText}>{"WO -> Week Off"}</Text>
            <Text style={styles.legendText}>{"IR -> IR Regular"}</Text>
          </View>
          {renderSummaryTable(summaryPageData)}

          {renderFooter(pages.length + i + 1)}
        </Page>
      ))}

    </Document>
  );
};

export default AttendanceHistoryPDF;









// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image
// } from "@react-pdf/renderer";

// const styles = StyleSheet.create({
//   page: {
//     paddingTop: 90,
//     paddingBottom: 80,
//     paddingHorizontal: 10,
//     fontSize: 6,
//     flexDirection: "column",
//   },

//   section: {
//     marginBottom: 10,
//   },

//   headerWrapper: {
//     position: "absolute",
//     top: 15,
//     left: 20,
//     right: 20,
//     height: 50,
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   headerImage: {
//     width: "100%",
//     height: 50,
//     objectFit: "contain",
//   },

//   footerWrapper: {
//     position: "absolute",
//     bottom: 25,
//     left: 5,
//     right: 5,
//     height: 80,
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   footerImage: {
//     width: "100%",
//     height: 100,
//     objectFit: "cover",
//   },

//   headerText: {
//     fontSize: 12,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 10,
//   },

//   legendContainer: {
//     flexDirection: "row",
//     flexWrap: "wrap",
//     marginBottom: 6,
//     gap: 10,
//   },

//   legendText: {
//     fontSize: 7,
//     fontWeight: "bold",
//   },

//   table: {
//     display: "table",
//     width: "100%",
//     borderWidth: 1,
//     borderColor: "#000",
//     borderStyle: "solid",
//     borderBottomWidth: 0
//   },

//   tableRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: "#000",
//   },

//   headerCell1: {
//     flex: 0.5,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold",
//   },

//   headerCell: {
//     flex: 6,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold",
//   },

//   headerCell2: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//     fontWeight: "bold",
//   },

//   headerCell2Total: {
//     flex: 1,
//     padding: 2,
//     backgroundColor: "#eee",
//     textAlign: "center",
//     fontWeight: "bold",
//   },

//   cell1: {
//     flex: 0.5,
//     padding: 2,
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//   },

//   cell: {
//     flex: 6,
//     padding: 2,
//     textAlign: "left",
//     borderRightWidth: 1,
//     borderColor: "#000",
//   },

//   cell2: {
//     flex: 1,
//     padding: 2,
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderColor: "#000",
//   },

//   cell2Total: {
//     flex: 1,
//     padding: 2,
//     textAlign: "center",
//   },
// });

// // Pagination
// const paginateData = (data) => {
//   if (!Array.isArray(data)) return [];
//   const firstPage = data.slice(0, 20);
//   const otherPages = [];

//   for (let i = 20; i < data.length; i += 26) {
//     otherPages.push(data.slice(i, i + 26));
//   }

//   return [firstPage, ...otherPages];
// };

// const AttendanceHistoryPDF = ({ data = [], filters = {} }) => {
//   const pages = paginateData(data);

//   const monthNames = [
//     "January","February","March","April","May","June",
//     "July","August","September","October","November","December"
//   ];

//   // ✅ Dynamic Day Color Function
//   const getDayStyle = (value) => {
//     switch (value) {
//       case "WO":
//         return { color: "#ab003c", backgroundColor: "#ffe6ee" };
//       case "HO":
//         return { color: "#0b5ed7", backgroundColor: "#e7f1ff" };
//       case "L":
//         return { color: "#ff8c00", backgroundColor: "#fff3cd" };
//       case "A":
//         return { color: "#dc3545" };
//       default:
//         return {};
//     }
//   };

//   return (
//     <Document>
//       {pages.map((pageData, pageIndex) => (
//         <Page size="A4" orientation="landscape" style={styles.page} key={pageIndex}>

//           {/* Header Image */}
//           <View fixed style={styles.headerWrapper}>
//             {filters.HeaderImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
//                 style={styles.headerImage}
//               />
//             )}
//           </View>

//           {/* Title */}
//           {pageIndex === 0 && (
//             <View style={styles.section}>
//               <Text style={styles.headerText}>
//                 {`Monthly Attendance Report (${monthNames[filters.Month - 1]} - ${filters.Year})`}
//               </Text>
//             </View>
//           )}

//           {/* Legend */}
//          <View style={styles.legendContainer}>
//   <Text style={styles.legendText}>{"P -> Present"}</Text>
//   <Text style={styles.legendText}>{"A -> Absent"}</Text>
//   <Text style={styles.legendText}>{"HO -> Holiday"}</Text>
//   <Text style={styles.legendText}>{"WO -> Week Off"}</Text>
//   <Text style={styles.legendText}>{"L -> Leave"}</Text>
//   <Text style={styles.legendText}>{"IR -> IR Regular"}</Text>
// </View>

//           {/* Table */}
//           <View style={styles.table}>
//             {/* Header Row */}
//             <View style={styles.tableRow}>
//               <Text style={styles.headerCell1}>SL#</Text>
//               <Text style={styles.headerCell}>EMPLOYEE</Text>

//               {Array.from({ length: 31 }, (_, i) => (
//                 <Text key={i} style={styles.headerCell1}>{i + 1}</Text>
//               ))}

//               <Text style={styles.headerCell2}>P</Text>
//               <Text style={styles.headerCell2}>UL</Text>
//               <Text style={styles.headerCell2}>AB</Text>
//               <Text style={styles.headerCell2}>HOL</Text>
//               <Text style={styles.headerCell2}>WO</Text>
//               <Text style={styles.headerCell2Total}>Total</Text>
//             </View>

//             {/* Body Rows */}
//             {pageData.map((row, rowIndex) => (
//               <View key={rowIndex} style={styles.tableRow}>
//                 <Text style={styles.cell1}>{row.SLNO}</Text>
//                 <Text style={styles.cell}>{row.Name}</Text>

//                 {/* ✅ Dynamic Days */}
//                 {Array.from({ length: 31 }, (_, i) => {
//                   const dayValue = row[`Day${i + 1}`];
//                   return (
//                     <Text
//                       key={i}
//                       style={[styles.cell1, getDayStyle(dayValue)]}
//                     >
//                       {dayValue}
//                     </Text>
//                   );
//                 })}

//                 <Text style={styles.cell2}>{row.Present}</Text>
//                 <Text style={styles.cell2}>{row.UNPAID_LEAVE}</Text>
//                 <Text style={styles.cell2}>{row.Absent}</Text>
//                 <Text style={styles.cell2}>{row.HOLIDAYS}</Text>
//                 <Text style={styles.cell2}>{row.Weekoff}</Text>
//                 <Text style={styles.cell2Total}>{row.Total}</Text>
//               </View>
//             ))}
//           </View>

//           {/* Footer Image */}
//           <View fixed style={styles.footerWrapper}>
//             {filters.FooterImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
//                 style={styles.footerImage}
//               />
//             )}
//           </View>

//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default AttendanceHistoryPDF;
